/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	export class FreeCameraAttitude {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(position:THREE.Vector3 = null, rotation:THREE.Euler = null) {
			this.position = new THREE.Vector3();
			this.rotation = new THREE.Euler();

			this.set(position || new THREE.Vector3(0, 0, 0), rotation || new THREE.Euler(0, 0, 0));
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public set(position:THREE.Vector3, rotation:THREE.Euler):void {
			this.position.copy(position);
			this.rotation.copy(rotation);
		}

		public getPosition():THREE.Vector3 {
			return this.position;
		}

		public getRotation():THREE.Euler {
			return this.rotation;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private position:THREE.Vector3;
		private rotation:THREE.Euler;
	}
}
